// ============================================================================
// LE CODE ARTICLE PROPOSÉ — dérivé de la désignation quand rien d'autre ne le donne.
//
// UTILITÉ : le code article regroupe les déclinaisons d'un même modèle (couleurs × tailles). Les écrans de
// création le PROPOSENT (modifiable), l'import de fichier le POSE quand le fichier n'en a pas : la même
// désignation doit donner le même code partout, sinon un article créé à l'écran et sa déclinaison
// importée deviendraient deux modèles.
//
// ⚠️ UNE COLLISION EST VOULUE, PAS ÉVITÉE : deux désignations qui donnent le même code désignent le même
//    modèle, et la nouvelle déclinaison rejoint l'ancien (c'est l'autre usage du champ — rattacher une
//    déclinaison à un modèle existant). Rendre le code unique à coups de suffixes casserait ce rattachement.
// ⚠️ « Œ » ET « Æ » SE DÉPLIENT (« CŒUR » → « COEUR ») : la décomposition Unicode ne les sépare pas, et sans
//    ce dépliage la lettre devenait un tiret (« C-UR »).
// ============================================================================

/** Longueur maximale d'un code proposé — celle que les écrans affichent sans le couper. */
export const ARTICLE_CODE_MAX = 24;

/** Ce que rend une désignation sans aucune lettre ni chiffre exploitable. */
export const ARTICLE_CODE_FALLBACK = 'ART';

/** Le code article proposé pour une désignation : majuscules sans accents, mots reliés par des tirets. */
export function proposeArticleCode(name: string): string {
  const base = name.trim().toUpperCase()
    .replace(/Œ/g, 'OE').replace(/Æ/g, 'AE')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  // ⚠️ LA COUPE PEUT TOMBER SUR UN TIRET : on le retire après coup, sinon « CHEMISE-OXFORD-MANCHES-» finit
  //    par un séparateur qui ne sépare rien.
  return base.slice(0, ARTICLE_CODE_MAX).replace(/-+$/, '') || ARTICLE_CODE_FALLBACK;
}
